export function jsonParse(data: string | null) {
  try {
    if (data) {
      return JSON.parse(data);
    }

    return null;
  } catch {
    return data;
  }
}
